export const navigation = {
  methods: {
    back () {
      window.history.go( -1 );
    },
    redirect ( url ) {
      window.location.href = url;
    },
  },
};

export const utils = {
  methods: {
    isNullOrEmpty ( val ) {
      return val == null || val === "";
    },
    getURLParams () {
      const queryParams = window.location.search
        .substr( 1 )
        .split( "&" )
        .reduce( ( q, query ) => {
          const chunks = query.split( "=" );
          const key = chunks[0];
          let value = decodeURIComponent( chunks[1] );
          value = Number.isNaN( Number( value ) ) ? value : Number( value );
          const result = ( ( q[key] = value ), q );
          return result;
        }, {} );

      return queryParams;
    },
    print () {
      window.print();
    },
    copy ( txt ) {
      navigator.clipboard
        .writeText( txt )
        .then( () => {
          this.$bvToast.toast( "Copied survey link to clipboard", {
            title: "Done!",
            autoHideDelay: 600,
            variant: "success",
            toaster: "b-toaster-top-right",
            appendToast: true,
          } );
        } )
        .catch( err => {
          console.error( "Error in copying text: ", err );
          this.$bvToast.toast( "Failed to copy link, please try manually.", {
            title: "Done!",
            autoHideDelay: 600,
            variant: "danger",
            toaster: "b-toaster-bottom-right",
            appendToast: true,
          } );
        } );
    },
    printElement ( element, appendStyleSheets = true ) {
      if ( this.isIE() ) {
        window.print();
      } else {
        const printArea = window.open();
        printArea.document.write( element.innerHTML );

        if ( appendStyleSheets ) {
          const css = document.createElement( "style" );
          css.media = "print";

          // create css stylesheet containing all of the available styles
          for ( let i = 0; i < document.styleSheets.length; i += 1 ) {
            try {
              const styleSheet = document.styleSheets[i];
              const { cssRules } = styleSheet;

              for ( let i2 = 0; i2 < cssRules.length; i2 += 1 ) {
                const rule = cssRules[i2];
                const { cssText } = rule;
                css.appendChild( document.createTextNode( cssText ) );
              }
            } catch ( ex ) {
              console.warn( ex );
            }
          }
          printArea.document.getElementsByTagName( "head" )[0].appendChild( css );
        }
        printArea.focus();
        printArea.print();
        // printArea.close();
      }
    },
    isIE () {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf( "MSIE " );

      let result = false;

      // eslint-disable-next-line
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        // if Internet Explorer, log version number
        console.info( Number.parseInt( ua.substring( msie + 5, ua.indexOf( ".", msie ) ), 10 ) );
        result = true;
      }

      return result;
    },
  },
};

export const isMobile = {
  data: () => ( {
    windowWidth: 0,
    maxMobileWidth: 992,
  } ),
  mounted () {
    window.addEventListener( "resize", this.setScreenWidth );
  },
  unmounted () {
    window.removeEventListener( "resize", this.setScreenWidth );
  },
  computed: {
    isMobile () {
      return this.windowWidth < this.maxMobileWidth && window.innerWidth < this.maxMobileWidth;
    },
  },
  methods: {
    setScreenWidth () {
      this.windowWidth = window.innerWidth;
    },
  },
};

export const backInterceptor = {
  data: {
    // asynchronous save data method
    interceptorSaveCurrentDataMethod: undefined,
  },
  created () {
    window.addEventListener( "load", this.onLoad );
  },
  beforeDestroy () {
    window.removeEventListener( this.onPopState );
    window.removeEventListener( this.onLoad );
  },
  methods: {
    onLoad () {
      /*
      ensure history has a state to trigger the onpopstate event.
      note: an interaction with the page in any manner is also required
      */
      window.history.pushState( {}, "", window.location.pathname );
      window.addEventListener( "popstate", this.onPopState );
    },
    onPopState () {
      return setTimeout( () => {
        if ( this.isBackConfirmed() ) {
          window.history.back();
        } else {
          // ensure state
          window.history.pushState( {}, "", window.location.pathname );
        }
      }, 0 );
    },
    isBackConfirmed () {
      // eslint-disable-next-line no-alert
      return window.confirm(
        "If you leave now any changes you have made may be lost. Are you sure you want to leave?",
      );
    },
    setAsyncInterceptorSaveMethod ( saveMethod ) {
      this.interceptorSaveCurrentDataMethod = saveMethod;
    },
    interceptorGoTo ( redirectUrl ) {
      window.location.href = redirectUrl;
    },
    interceptorPrevious ( url ) {
      if ( this.isBackConfirmed() ) {
        this.interceptorGoTo( url );
      }
    },
    async interceptorNext ( url ) {
      try {
        if ( this.interceptorSaveCurrentDataMethod ) {
          await this.interceptorSaveCurrentDataMethod();
        }
        this.interceptorGoTo( url );
      } catch ( ex ) {
        console.error();
      }
    },
  },
};
